import React, { useContext, useEffect, useState } from "react";
import { FormControlLabel, Stack, Switch, TextField, Typography } from "@mui/material";
import { StringObj } from "../../../../../../type";
import { QuestionsContext } from "../../../../../../provider/MyContexts";

const formLabels: StringObj = {
  client: "クライアント名",
  theme: "調査テーマ",
  backGround: "調査の背景",
};

export default function InfoForm() {
  const { researchInfo, updateResearchInfo, isDeepThought, toggleDeepThought } =
    useContext(QuestionsContext);

  const [inputs, setInputs] = useState({
    client: "",
    theme: "",
    backGround: "",
  });

  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { name, value, id } = e.target;
    setInputs((prev) => ({ ...prev, [id]: value }));
  }

  function syncState(key: string) {
    updateResearchInfo(key, inputs[key as keyof typeof inputs]);
  }

  useEffect(() => {
    setInputs({
      client: researchInfo.client || "",
      theme: researchInfo.theme || "",
      backGround: researchInfo.backGround || "",
    });
  }, [researchInfo]);

  return (
    <Stack width={"100%"} spacing={1.5} padding={2} marginTop={2}>
      {Object.entries(formLabels).map(([key, label], index) => (
        <TextField
          key={index}
          id={key}
          value={inputs[key as keyof typeof inputs]}
          onChange={handleInputChange}
          onBlur={() => syncState(key)}
          // disabled={isLoading}
          label={label}
          variant="outlined"
          fullWidth
          size="small"
          maxRows={key == "client" ? 1 : 10}
          multiline={key != "client"}
          // rows={key == "client" ? 1 : key == "theme" ? 2 : 3}
          placeholder={
            key === "theme"
              ? "調査目的や聴取したい内容を簡潔に記入してください"
              : key === "backGround"
                ? "調査の背景や聴取対象のブランドについての情報を記入してください"
                : ""
          }
        />
      ))}

      <Stack>
        <FormControlLabel
          control={<Switch onClick={toggleDeepThought} checked={isDeepThought} />}
          label={<Typography variant="label_M">AI熟考モード（応答に時間がかかります）</Typography>}
        />
      </Stack>
    </Stack>
  );
}
